<template>
	<div class="switch-language-wrapper">
		<el-dropdown placement="bottom" trigger="hover" @command="switchLocale">
			<span><c-svg-icons name="language" size="24" /></span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item :command="ZH">简体中文</el-dropdown-item>
				<el-dropdown-item :command="EN">English</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>

<script setup>

import i18n, { EN, ZH, LANGUAGE_LIST, defaultLanguage, changeLocaleLang } from '@/locales';
import { useRoute, useRouter } from '@/utils/api';

const route = useRoute();
const router = useRouter();

const switchLocale = locale => {
	if (!LANGUAGE_LIST.includes(locale)) {
		locale = defaultLanguage;
	}
	if (locale === i18n.locale) {
		return;
	}

	// 获取当前路径并移除语言前缀
	const actualPath = window.location.pathname;
	// 从实际路径中提取语言信息（而不是依赖 route.params.lang）
	const currentLang = actualPath.startsWith('/en/') || actualPath === '/en' ? 'en' : null;
	let currentPath = actualPath;
	if (currentLang) {
		currentPath = actualPath === `/${currentLang}` 
			? '/index' 
			: actualPath.replace(`/${currentLang}`, '') || '/index';
	}
	
	// 构建目标路径（currentPath 已经移除了语言前缀）
	const newPath = locale === EN ? `/en${currentPath}` : currentPath;
	
	changeLocaleLang(locale);
	
	if (newPath !== actualPath) {
		router.replace({
			path: newPath,
			query: route.query
		});
	}
};
</script>

<style lang="less" scoped>
.switch-language-wrapper {
	position: absolute;
	top: 0;
	right: 8%;
	height: 80px;
	display: flex;
	padding-bottom: 17px;
	align-items: flex-end;
}
</style>
